import { StyleSheet, View, Text } from '@react-pdf/renderer';
import { TableRowHeaderProps } from '../TablePage';
import { getHeaderColumnWidth } from './helpers';

export const TableRowHeader = ({
  data, fontWeight = 'normal',

}: TableRowHeaderProps) => {
  const styles = StyleSheet.create({
    wrapper: {
      display: 'flex',
      flexDirection: 'row',
      paddingTop: 4,
      paddingBottom: 4,
      width: "100%"
    },
    text: {
      fontFamily: 'Chivo',
      fontSize: 8,
      paddingLeft: 5,
      paddingRight: 5,
      display: "flex",
    },
  });

  return (
    <View
      style={{
        ...styles.wrapper,
        backgroundColor: '#ffffff',
        borderBottom: "1px solid black"
      }}>
      {data.map((item: string, key: number) => {
        const style: object = getHeaderColumnWidth(item);
        return (
          <View key={key} style={{ ...style, flex: "1 1", flexWrap: 'nowrap' }}>
            <Text style={{ ...styles.text, fontWeight: fontWeight }}>
              {item}
            </Text>
          </View>
        );
      })}
    </View>
  );
};
